import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a091a72f6558f0014d29ae2/miraclechain/src/app/admin-panel/components/AdminDashboardContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a091a72f6558f0014d29ae2/miraclechain/src/components/AdminSidebar.tsx");
